export default __webpack_public_path__ + "static/media/Logo_Trust_ROLE1@3x.cbb46cf9.png";